import { useFleet } from '../../state/store'
import type { MbmtStatusEvent } from '../../lib/types'

export type { MbmtStatusEvent }

/** Live TUPL status by vehicle_id, from the SAME shared /events SSE connection every
 *  other site uses (serving/app.py's _publish/subscribers) -- not a second
 *  EventSource. Mirrors useMbmtStatusEvents.ts exactly; see that file's own history for
 *  why ('tupl_status' is handled in store.ts's applyEvent switch, this hook is just a
 *  selector over that state). */
export function useTuplStatusEvents(): Record<string, MbmtStatusEvent> {
  return useFleet((s) => s.tuplStatus)
}
